import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu,
	KLink
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "ThirdPartyServicesTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no 3rd party services to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching 3rd party services found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "third_party_services"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "name"
				},
				{
					text: "Website",
					value: "url"
				},
				{
					text: "Price",
					value: "price"
				},
				{
					text: "Description",
					value: "description"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteService( Service ) {
			const deleteIndex = this.items.findIndex( item =>
				Service.id === item.id
			);

			return Service.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.url": ( { item } ) => (
					item.url
						? <KLink
							href={item.url}
							icon="open_in_new"
							target="_blank"
						>Go to website</KLink>
						: "--"
				),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "thirdPartyService",
								params: { idThirdPartyService: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete third party service" )}
								onConfirm={() => this.deleteService( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete 3rd Party Service"
							>
								Are you sure you want to delete the 3rd party service <strong>{item.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
